let target = document.querySelector('.cart-giftbox');

if(target){
    window.addEventListener("load", ()=>{
        if(window.location.href.includes("/cart")){return}
        let checkbox = document.querySelector(".cart-giftbox__switch");
        let variantID = document.querySelector('.cart-giftbox__button').dataset.id;
    
        if (checkbox && variantID) {
            if ( document.querySelector(`.cart__item__remove[data-id*="${variantID}"]`) ) {
                checkbox.setAttribute('checked', true);
                checkboxChecker();
            } else {
                checkboxChecker();
            }
    
            function checkboxChecker() {
                checkbox.addEventListener('change', function() {
                    if (this.checked) {
                        let button = document.querySelector('.btn.cart-giftbox__button');
                        sendRecommendedProductForm(button);
                    } else {
                        document.querySelector(`.cart__item__remove[data-id*="${variantID}"]`).click();
                    }
                });
            }
            
            async function sendRecommendedProductForm(btn) {
                document.dispatchEvent(
                    new CustomEvent("theme:cart:add", {
                        detail: {
                            button: btn,
                        },
                    }),
                )
            }
    
        }
    })
}
